import { styled, Typography } from "@mui/material";
import { StyledAvatar } from "components/Shared/Dashboard/styled";
import UploadImageComponent from "components/Input/UploadImageComponent";
import ColorPicker from "components/Input/ColorPicker";
import uploadHeaderImg from "assets/images/uploadHeader.svg";
import uploadBackgroundImg from "assets/images/uploadBackground.svg";

const BackgroundChildContainer = styled("div")(({ theme }) => ({
  padding: "24px",
}));
const UpperComponent = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "32px",
}));
const UploadContentContainer = styled("div")(({ theme }) => ({
  height: 330,
  padding: "12px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "center",
  border: "1px solid #F1F1F1",
}));

const AvatarContainer = styled("div")(({ theme }) => ({
  width: "22px",
  height: "32px",
}));

const HeaderLogoPalceholder = () => {
  return (
    <AvatarContainer>
      <StyledAvatar sx={{ borderRadius: 0 }} src={uploadHeaderImg} />
    </AvatarContainer>
  );
};

const AvatarBackgroundContainer = styled("div")(({ theme }) => ({
  width: "80px",
  height: "60px",
}));

const BackgroundLogoPalceholder = () => {
  return (
    <AvatarBackgroundContainer>
      <StyledAvatar sx={{ borderRadius: 0 }} src={uploadBackgroundImg} />
    </AvatarBackgroundContainer>
  );
};

const BackgroundChild = () => {
  return (
    <BackgroundChildContainer>
      <UpperComponent>
        <Typography variant="body2">رنگ پس زمینه</Typography>
        {/* <StyledSelect /> */}
        <ColorPicker name="backroundColor" />
      </UpperComponent>
      <UploadContentContainer>
        <UploadImageComponent
          title="آپلود سربرگ"
          name="header"
          width={181}
          height={76}
          innerWidth={160}
          innerHeight={60}
          horizontal={true}
          LogoPlaceholder={HeaderLogoPalceholder}
        />
        <UploadImageComponent
          title="آپلود تصویر پس زمینه"
          name="background"
          width={181}
          height={181}
          innerWidth={164}
          innerHeight={164}
          LogoPlaceholder={BackgroundLogoPalceholder}
        />
      </UploadContentContainer>
    </BackgroundChildContainer>
  );
};

export default BackgroundChild;
